import { ComponentPropsWithoutRef } from 'react';
import BeyondPricingIcon from 'assets/images/icons/partners/beyondpricing.svg?react';
import DpgoIcon from 'assets/images/icons/partners/dpgo.svg?react';
import NightpricerIcon from 'assets/images/icons/partners/nighpricer.svg?react';
import PriceLabsIcon from 'assets/images/icons/partners/pricelabs.svg?react';
import QuibbleIcon from 'assets/images/icons/partners/quibble.svg?react';
import TurboSuiteIcon from 'assets/images/icons/partners/turbosuite.svg?react';
import WheelhouseIcon from 'assets/images/icons/partners/wheelhouse.svg?react';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';

interface AffiliateIconProps extends ComponentPropsWithoutRef<'svg'> {
  affiliate: IntegrationEnum;
}

const AffiliateIcon = ({ affiliate, ...props }: AffiliateIconProps) => {
  switch (affiliate) {
    case IntegrationEnum.BEYONDPRICING:
      return <BeyondPricingIcon {...props} />;
    case IntegrationEnum.DPGO:
      return <DpgoIcon {...props} />;
    case IntegrationEnum.NIGHTPRICER:
      return <NightpricerIcon {...props} />;
    case IntegrationEnum.PRICELABS:
      return <PriceLabsIcon {...props} />;
    case IntegrationEnum.QUIBBLE:
      return <QuibbleIcon {...props} />;
    case IntegrationEnum.TURBOSUITE:
      return <TurboSuiteIcon {...props} />;
    case IntegrationEnum.WHEELHOUSE:
      return <WheelhouseIcon {...props} />;
    default:
      return null;
  }
};

export default AffiliateIcon;
